import { useMemo } from 'react';

import { Filter } from 'components/filter';
import { useListQuery } from 'store/api/employees';
import { FilterSectionType } from 'components/filter-section';

import { FilterValues, FiltersProps } from '../types';

import { initialValues, statusOptions } from './config';

const commonFilterProps = {
  type: FilterSectionType.Select,
  selectProps: { isMulti: true },
};

export const Filters = ({
  isOpen,
  values,
  setFilters,
  setFilterOpened,
}: FiltersProps) => {
  const { data: employees } = useListQuery({ limit: 10000 });

  const employeeOptions = useMemo(
    () =>
      employees?.rows?.map((value) => ({
        label: value.user.name,
        value: value.user?.id?.toString(),
      })) || [],
    [employees?.rows]
  );

  return (
    <Filter<FilterValues>
      isOpen={isOpen}
      values={values}
      onApply={setFilters}
      initialValues={initialValues}
      onClose={() => setFilterOpened(false)}
      sections={[
        {
          ...commonFilterProps,
          name: 'userIds',
          title: 'Employee',
          options: employeeOptions,
        },
        {
          name: 'status',
          title: 'Status',
          options: statusOptions,
          type: FilterSectionType.Radio,
        },
      ]}
    />
  );
};
